import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_AREAS,
  ADD_AREA,
  UPDATE_AREA,
  DELETE_AREA,
} from "./actionTypes";
import {
  getAreasSuccess,
  getAreasFail,
  addAreaSuccess,
  addAreaFail,
  updateAreaSuccess,
  updateAreaFail,
  deleteAreaSuccess,
  deleteAreaFail,
  getAreas,
} from "./actions";
import axiosInstance from "pages/Utility/axiosInstance";

// API Calls
const fetchAreasApi = () =>
  axiosInstance.get("", { params: { sp: "usp_GetAreas" } });

const addAreaApi = (data) =>
  axiosInstance.post("", { sp: "usp_InsertArea", ...data });

const updateAreaApi = (data) =>
  axiosInstance.post("", { sp: "usp_UpdateArea", ...data });

const deleteAreaApi = (id) =>
  axiosInstance.post("", { sp: "usp_DeleteArea", areaId: id });

// Workers
function* getAreasSaga() {
  try {
    const { data } = yield call(fetchAreasApi);
    yield put(getAreasSuccess(data));
  } catch (error) {
    yield put(getAreasFail(error.response?.data || error.message));
  }
}

function* addAreaSaga({ payload }) {
  try {
    const { data } = yield call(addAreaApi, payload);
    yield put(addAreaSuccess(data));
    yield put(getAreas()); // refresh list
  } catch (error) {
    yield put(addAreaFail(error.response?.data || error.message));
  }
}

function* updateAreaSaga({ payload }) {
  try {
    const { data } = yield call(updateAreaApi, payload);
    yield put(updateAreaSuccess(data));
    yield put(getAreas()); // refresh list
  } catch (error) {
    yield put(updateAreaFail(error.response?.data || error.message));
  }
}

function* deleteAreaSaga({ payload }) {
  try {
    yield call(deleteAreaApi, payload);
    yield put(deleteAreaSuccess(payload));
    yield put(getAreas()); // refresh list
  } catch (error) {
    yield put(deleteAreaFail(error.response?.data || error.message));
  }
}

// Watchers
function* areaSaga() {
  yield takeEvery(GET_AREAS, getAreasSaga);
  yield takeEvery(ADD_AREA, addAreaSaga);
  yield takeEvery(UPDATE_AREA, updateAreaSaga);
  yield takeEvery(DELETE_AREA, deleteAreaSaga);
}

export default areaSaga;
